<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Animales</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
        
        </select>
      </search-filter>
      <inertia-link v-if="$page.props.auth.user.rol !='Cliente'" class="btn-indigo" :href="route('animales.create')">
        <span>Agregar</span>
        <span class="hidden md:inline">Animales</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Código</th>
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <th class="px-6 pt-6 pb-4">Arete</th>
          <th class="px-6 pt-6 pb-4">Especie</th>
          <th class="px-6 pt-6 pb-4">Sexo</th>
          <th class="px-6 pt-6 pb-4">Fecha Nacimiento</th>
          <th class="px-6 pt-6 pb-4">Peso</th>
          <th class="px-6 pt-6 pb-4">Bitacora</th>
        </tr>
        <tr v-for="animal in animales.data" :key="animal.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('animales.edit', animal.id)" tabindex="-1">
              {{ animal.codigo }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('animales.edit', animal.id)" tabindex="-1">
              {{ animal.nombre }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('animales.edit', animal.id)" tabindex="-1">
              {{ animal.arete }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('animales.edit', animal.id)" tabindex="-1">
              {{ animal.especie }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('animales.edit', animal.id)" tabindex="-1">
              {{ animal.sexo }}
            </inertia-link>
          </td>

        <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('animales.edit', animal.id)" tabindex="-1">
              {{ animal.fecha_nacimiento }}
            </inertia-link>
        </td>
        <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('animales.edit', animal.id)" tabindex="-1">
              {{ animal.peso }}
            </inertia-link>
          </td>
        <td class="border-t px-6 py-4">
          <inertia-link class="btn-indigo"
          :href="route('animales.bitacora', { animal: animal.id })">
           Bitácora
          </inertia-link>
        </td>
        </tr>
        <tr v-if="animales.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Animales</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="animales.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Animales' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    animales: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('animales'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
